import { render, staticRenderFns } from "./ChatContextMenu.vue?vue&type=template&id=0f5c0764"
import script from "./ChatContextMenu.vue?vue&type=script&lang=js"
export * from "./ChatContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports